import { experimentalMutate } from '@confluence/legacy-schema-bridge/entry-points/experimentalMutate.ts';
import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';
import { safeJSONParse } from '@confluence/graphql/entry-points/safeJSONParse.ts';
import { getEditDraftPageUrl } from '@confluence/graphql/entry-points/sharedTemplateBlueprintReqFns.ts';

export const experimentalPublishPageByTemplateMutate = ({
	variables,
}: {
	variables: ExperimentalPublishPageByTemplateVariables;
}) => {
	const blueprintSpec = safeJSONParse(variables.blueprint);
	const contextValue = variables.context && safeJSONParse(variables.context);

	const commonContentProperties: any = {
		type: 'page',
		status: 'draft',
		space: {
			key: variables.spaceKey,
		},
		title: variables.title,
	};

	if (variables.parentPageId && variables.parentPageId !== 'no-parent-page') {
		commonContentProperties.ancestors = [{ id: variables.parentPageId }];
	}

	if (variables.subType) {
		commonContentProperties.subType = variables.subType;
	}

	return experimentalMutate<
		ExperimentalPublishPageByTemplateData,
		ExperimentalPublishPageByTemplateVariables,
		PublishPageByTemplateResponse
	>({
		url: `/wiki/rest/api/template/page/${blueprintSpec.templateId}/instance${
			variables.attemptSpaUrlResponse ? '?expand=metadata.properties.editor,space' : ''
		}`,
		method: 'POST',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		body: JSON.stringify({
			content: {
				...commonContentProperties,
			},
			contentBlueprintSpec: {
				contentTemplateId: blueprintSpec.templateId,
				context: contextValue || {},
			},
		}),
		variables,
		parseResult: async (response) => {
			const editui = await getEditDraftPageUrl(response, variables.attemptSpaUrlResponse);

			if (!editui) {
				throw new Error('Missing content draft url');
			}

			return {
				experimentalPublishPageByTemplate: {
					links: {
						draftUrl: editui,
					},
				},
			};
		},
	});
};

interface ExperimentalPublishPageByTemplateVariables {
	spaceKey: string;
	parentPageId?: string;
	blueprint: string;
	context?: string;
	title?: string;
	attemptSpaUrlResponse?: boolean;
	forceTemplatePanelOpen?: boolean;
	subType?: string;
}

interface ExperimentalPublishPageByTemplateData {
	experimentalPublishPageByTemplate: {
		links: {
			draftUrl: string | null;
		} | null;
	} | null;
}

interface PublishPageByTemplateResponse {
	_links?: {
		editui?: string;
	};
	metadata?: {
		properties?: {
			editor?: {
				value?: string;
			};
		};
	};
}
